import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Las dietas extremas no consideran los químicos ambientales.', 'Los suplementos energéticos solo enmascaran el problema sin resolver la raíz.', 'Los detox de jugos no eliminan los disruptores hormonales en tu rutina diaria.', 'Eliminar calorías sin eliminar toxinas es como vaciar un balde con agujeros.'];
  return <section className="py-24 bg-cream" data-id="element-12">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-6" data-id="element-15">
            Por qué lo que has intentado no funcionó
          </h2>
          <p className="text-lg text-dark/70 max-w-2xl mx-auto" data-id="element-16">
            La industria del bienestar a menudo ignora la verdadera causa de la
            inflamación y la fatiga.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
          {failures.map((failure, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-white rounded-2xl shadow-sm border border-sage-light/50" data-id="element-18">
              <XCircle className="w-6 h-6 text-red-400/80 shrink-0 mr-4 mt-0.5" data-id="element-19" />
              <p className="text-dark/80 text-lg leading-relaxed line-through decoration-red-400/30 decoration-2" data-id="element-20">
                {failure}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}